import { NavLink } from "react-router-dom";
import { DRINK__ROUTES, KITCHEN_ROUTES } from "../../routes/ROUTES";

export default function MarkupNav() {
  return (
    <div className="container">
      <div className="markup__wrapper">
        {KITCHEN_ROUTES.map(({ route, title }) => (
          <NavLink to={route} key={route} className="markup__wrapper--item nav">
            {title}
          </NavLink>
        ))}
      </div>

      <div className="markup__wrapper">
        {DRINK__ROUTES.map(({ route, title }) => (
          <NavLink to={route} key={route} className="markup__wrapper--item">
            {title}
          </NavLink>
        ))}
      </div>
    </div>
  );
}
